import { Injectable } from '@angular/core';
import { tap, withLatestFrom } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { dailySpApiUsageGet, dailySpApiUsageLoad } from '../actions/account.actions';
import { flashNotificationsFormValidationErrorWithDetails } from '../actions/flash-notifications.actions';
import { SpApiUsageService } from '../../../shared/services/sp-api-usage.service';
import { errorWizardGeneralError } from '../../../shared/constants/flash-notifications';

@Injectable()
export class DailySpApiUsageEffects {
  load$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dailySpApiUsageGet),
        withLatestFrom(this.store$.select('account')),
        tap(async ([{ days }, accountState]) => {
          try {
            // already loaded once -> do nothing
            if (accountState?.dailySpApiUsage) {
              return;
            }

            // First load only
            const result = await this.spApiUsageService.getLastNDays(days);

            this.store$.dispatch(
              dailySpApiUsageLoad({ dailySpApiUsage: result })
            );
          } catch (error: any) {
            this.store$.dispatch(
              flashNotificationsFormValidationErrorWithDetails({
                message: errorWizardGeneralError,
                details: error
              })
            );
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private spApiUsageService: SpApiUsageService,
    private store$: Store<AppState>
  ) {}
}

